import type { ReactNode } from "react";
import { Container, Grid, Skeleton, useMediaQuery } from "@mui/material";
import type { SxProps, Theme } from "@mui/material";
import ArticleCardSkeleton from "components/molecules/cards/ArticleCardSkeleton";
import { rangeUtil } from "utils/rangeUtil";

const noMarginsOnSmall: SxProps<Theme> = (theme: Theme) => ({
  [theme.breakpoints.only("xs")]: {
    p: 0,
    m: 0,
  },
});

function CataloguePageSkeleton(): ReactNode {
  const isLargeScreen = useMediaQuery((theme) => theme.breakpoints.down("xl"));

  return (
    <Container maxWidth={isLargeScreen ? "lg" : "xl"} sx={noMarginsOnSmall}>
      <Grid
        container
        direction="row"
        spacing={isLargeScreen ? 2 : 4}
        size={12}
        sx={{ alignItems: "center" }}>
        <Grid container size={12} sx={{ alignContent: "center", justifyContent: "center" }}>
          <Grid size={8}>
            <Skeleton height="70px" />
          </Grid>
        </Grid>
        {rangeUtil.arrayRange(6).map((i) => (
          <Grid key={i} size={{ xs: 12, lg: 6 }}>
            <ArticleCardSkeleton />
          </Grid>
        ))}
      </Grid>
    </Container>
  );
}

export default CataloguePageSkeleton;
